import React from 'react';
import ConfirmationModal from '../../ConfirmationModal';
import FlexAssignmentConfirmationModal from '../../FlexAssignmentConfirmationModal/FlexAssignmentConfirmationModal';
import FlexRequestShiftConfirmationModal from '../../FlexRequestShiftConfirmationModal/FlexRequestShiftConfirmationModal';
import ShiftsConfirmation from '../../../../features/shiftsToRequest/ShiftsConfirmation';
import LoadingSpinner from '../../../spinner/LoadingSpinner';
import facilityInfoIcon from '../../../../assets/images/facility-info-icon.svg';
import infoIcon from '../../../../assets/images/info-icon-black.svg';

const buildNonFlexTitle = ({ isHybrid, isOnCall }) => {
	let prefix = '';
	if (isHybrid) {
		prefix = 'Hybrid shift';
	} else if (isOnCall) {
		prefix = 'On Call shift';
	}
	return `Confirm ${prefix} request `;
};

const RequestShiftsConfirmation = ({
	isOpen,
	variant,
	onConfirm,
	onCancel,
	isSubmitting,
	selectedFacility,
	shiftsGroups,
	shiftStructures,
	currentFacilityUnits,
	showUnits,
	isHybrid,
	isOnCall
}) => {
	if (!isOpen) return null;

	if (variant === 'flex') {
		return (
			<FlexAssignmentConfirmationModal
				title="Confirm Internal Flex shift request"
				facilityLabel={selectedFacility?.label}
				shiftsGroups={shiftsGroups}
				shiftStructures={shiftStructures}
				currentFacilityUnits={currentFacilityUnits}
				facilityTimezone={selectedFacility?.timezone}
				showUnits={showUnits}
				showShiftsRequested
				onConfirm={onConfirm}
				onCancel={onCancel}
				confirmDisabled={isSubmitting}
				showLoadingSpinner={isSubmitting}
			/>
		);
	}

	if (variant === 'flex-past-shifts') {
		return (
			<FlexRequestShiftConfirmationModal
				title="Request shifts that have already started or ended?"
				textContent="One or more of the shifts you selected have already started or ended. Do you want to continue with this request anyway?"
				primaryActionLabel="Continue"
				onPrimaryAction={onConfirm}
				secondaryActionLabel="Go back"
				onHide={onCancel}
				primaryActionDisabled={isSubmitting}
				secondaryActionDisabled={isSubmitting}
			/>
		);
	}

	if (variant === 'flex-already-started') {
		return (
			<FlexRequestShiftConfirmationModal
				title="Shifts have already started, request anyway?"
				textContent="One or more of the shifts you selected have already started. Do you want to confirm this request anyway?"
				boxTextContent={
					<>
						<img src={infoIcon} alt="Info Icon" className="box-text-content-icon" />
						<span>
							<strong>Reminder:</strong> Shift modifications must be made before their scheduled end time.
						</span>
					</>
				}
				primaryActionLabel="Continue anyway"
				onPrimaryAction={onConfirm}
				secondaryActionLabel="Go back"
				onSecondaryAction={onCancel}
				onHide={onCancel}
				primaryActionDisabled={isSubmitting}
				secondaryActionDisabled={isSubmitting}
			/>
		);
	}

	return (
		<ConfirmationModal
			className="shifts-request-confirmation-modal"
			size="xl"
			title={buildNonFlexTitle({ isHybrid, isOnCall })}
			scrollable
			customModalBodyClass="modal-body-shift-confirmation"
			onConfirm={onConfirm}
			onCancel={onCancel}
			closeButton={false}
			cancelLabel="Go Back"
			confirmLabel="Confirm"
		>
			{isSubmitting && (
				<div className="spinner-wrapper">
					<LoadingSpinner />
				</div>
			)}
			<div>
				Facility: <span className="facility-name">{selectedFacility?.label || ''}</span>
			</div>
			<div className="facility-and-modal-container">
				<ShiftsConfirmation
					shiftsGroups={shiftsGroups}
					shiftStructures={shiftStructures}
					shiftsByDay={[]}
					facilityId={selectedFacility?.id}
					showUnits={showUnits}
					isHybrid={isHybrid}
					isOnCall={isOnCall}
				/>
				{(isHybrid || isOnCall) && (
					<div className="hybrid-guaranteed-info">
						<img className="tooltip-title" src={facilityInfoIcon} alt="info" />
						{isHybrid && <span>Note: Guaranteed shifts only apply to shifts claimed by ShiftMed professionals.</span>}
						{isOnCall && (
							<span>
								Note: This request will add On Call shifts that can only be claimed by On Demand professionals at this
								time
							</span>
						)}
					</div>
				)}
			</div>
		</ConfirmationModal>
	);
};

export default RequestShiftsConfirmation;
